export default {"src":"/_next/static/media/video.ee7d85fa.svg","height":17,"width":17};